import * as Yup from 'yup';

export const chatbotInputSchema = Yup.object({
  inputField: Yup.string().required('Please type something'),
});
